import { api } from "rdx/services/api";

type UpdateEmailRequestT = {
  email: string;
};

type UpdateEmailResponseT = {
  body?: { email?: string };
};

export const emailVerificationApi = api.injectEndpoints({
  endpoints: (builder) => ({
    updateEmail: builder.mutation<UpdateEmailResponseT, UpdateEmailRequestT>({
      query: ({ email }) => ({
        url: "email_verification/email",
        method: "PATCH",
        body: { email },
      }),
    }),
  }),
});

export const { useUpdateEmailMutation } = emailVerificationApi;
